// services/SubjectService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getSubjects(params = {}) {
    return api.get(ENDPOINTS.SUBJECTS.BASE, { params });
}
export function getSubjectById(id) {
    return api.get(ENDPOINTS.SUBJECTS.BY_ID(id));
}
export function createSubject(payload) {
    return api.post(ENDPOINTS.SUBJECTS.BASE, payload);
}
export function updateSubject(id, payload) {
    return api.patch(ENDPOINTS.SUBJECTS.BY_ID(id), payload);
}
export function deleteSubject(id) {
    return api.delete(ENDPOINTS.SUBJECTS.BY_ID(id));
}
export function restoreSubject(id) {
    return api.post(`${ENDPOINTS.SUBJECTS.BY_ID(id)}/restore`);
}
